<template>
    <div class="SalesYearContainer">
        <div class="SalesYear RoundElement" :title="Year + '年'">
            {{ Year }}
        </div>
        <div class="SalesMonthContainer">
            <div class="SalesMonth" :title="Year + '/' + Month">
                <div :id="Year + '/' + Month" class="SalesMonthTitle RoundElement" :title="Year + '/' + Month">
                    {{ Month }}月
                </div>
                <div class="SalesDestinationContainer">
                    <div class="MonthSalesData">
                        <div class="SalesDestination">
                            <div class="SalesDestinationTitle" :title="Year + '/' + Month">

                            </div>
                            <div class="SalesCategories">
                                <div class="SalesCategory" :title="Year + '/' + Month">
                                    <div class="SalesCategoryTitle RoundElement">
                                        仕入
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year + '/' + Month">
                                    <div class="SalesCategoryTitle RoundElement">
                                        原価計
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ZaikomeisaiDistributor v-for="distributor in DistributorNames" :key="distributor" :Year="Year" :Month="Month" :DistributorName="distributor"/>
                        <div class="ProductSamplesProcessing" :title="Year + '/' + Month">
                            <div class="SalesDestinationTitle ProductSamplesProcessingTitle" :title="Year + '/' + Month">
                                見本処理
                            </div>
                            <div class="SalesCategories">
                                <div class="SalesCategory" :title="Year + '/' + Month">
                                    <div class="SalesCategoryTitle RoundElement">
                                        処理数
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year + '/' + Month">
                                    <div class="SalesCategoryTitle RoundElement">
                                        損
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year + '/' + Month">
                                    <div class="SalesCategoryTitle RoundElement">
                                        出荷計
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year + '/' + Month">
                                    <div class="SalesCategoryTitle RoundElement">
                                        末pcs
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year + '/' + Month">
                                    <div class="SalesCategoryTitle RoundElement">
                                        末￥
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-for="n in 12" :key="n" class="SalesMonth" :title="Year.year + '/' + n">
                <div :id="Year.year + '/' + n" class="SalesMonthTitle RoundElement" :title="Year.year + '/' + n">
                    {{ n }}月
                </div>
                <div class="SalesDestinationContainer">
                    <div class="MonthSalesData">
                        <div class="SalesDestination">
                            <div class="SalesDestinationTitle" :title="Year + '/' + n">

                            </div>
                            <div class="SalesCategories">
                                <div class="SalesCategory" :title="Year + '/' + n">
                                    <div class="SalesCategoryTitle RoundElement">
                                        仕入
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year + '/' + n">
                                    <div class="SalesCategoryTitle RoundElement">
                                        原価計
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ZaikomeisaiDistributor v-for="distributor in DistributorNames" :key="distributor" :Year="Year.year" :Month="n" :DistributorName="distributor"/>
                        <div class="ProductSamplesProcessing" :title="Year.year + '/' + n">
                            <div class="SalesDestinationTitle ProductSamplesProcessingTitle" :title="Year.year + '/' + n">
                                見本処理
                            </div>
                            <div class="SalesCategories">
                                <div class="SalesCategory" :title="Year.year + '/' + n">
                                    <div class="SalesCategoryTitle RoundElement">
                                        処理数
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year.year + '/' + n">
                                    <div class="SalesCategoryTitle RoundElement">
                                        損
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year.year + '/' + n">
                                    <div class="SalesCategoryTitle RoundElement">
                                        出荷計
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year.year + '/' + n">
                                    <div class="SalesCategoryTitle RoundElement">
                                        末pcs
                                    </div>
                                </div>
                                <div class="SalesCategory" :title="Year.year + '/' + n">
                                    <div class="SalesCategoryTitle RoundElement">
                                        末￥
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import ZaikomeisaiDistributor from './ZaikomeisaiDistributor.vue';
export default{
    components:{
        ZaikomeisaiDistributor
    },
    props: {
        Year:Number,
        Month:Number,
        DistributorNames:Array,
    }
}
</script>